// Site colour theme. Light by default; `?tema=bordo` (or the toggle) switches
// to dark burgundy, `?tema=acik` back to light; the choice is remembered per visitor.
const KEY = 'lucien-tema';

export const initTheme = () => {
  let tema = null;
  try {
    const q = new URLSearchParams(window.location.search).get('tema');
    if (q === 'bordo' || q === 'acik') localStorage.setItem(KEY, q);
    tema = localStorage.getItem(KEY);
  } catch { /* storage unavailable: default theme */ }
  if (tema === 'bordo') document.documentElement.dataset.tema = 'bordo';
  else delete document.documentElement.dataset.tema;
};

export const isBordo = () => document.documentElement.dataset.tema === 'bordo';

// Tiles and the sky pick their colours at render time, so reload to apply.
export const toggleTheme = () => {
  try { localStorage.setItem(KEY, isBordo() ? 'acik' : 'bordo'); } catch { /* ignore */ }
  const u = new URL(window.location.href);
  u.searchParams.delete('tema');
  window.location.replace(u.toString());
};
